import axios from 'axios';

export default{
	namespaced: true,

	state:{
		id:"",
		width:0,
		height:0,
		monitor_uuid:"",
		url:"",
		type:"",
		message:"",
		success:"",
	},

	actions:{
		getPlatformInfo({commit},{monitor_uuid, platform}){
			axios.get(`https://insightaudience.bindez.com/api/dynamicmenu/${monitor_uuid}/${platform}`)
				.then(({data}) => {
					commit("setPlatformInfo", data);
				})
		}
	},

	mutations:{
		setPlatformInfo(state, {data = {}, message, success}){
			({
				id:state.id="",
				width:state.width=0,
				height:state.height=0,
				monitor_uuid:state.monitor_uuid="",
				url:state.url="",
				type:state.type="",
			} = data);
			state.message = message;
			state.success = success;
		}
	}
}
